module.exports = __webpack_public_path__ + "static/media/indentplanner4.a11a1750.png";